exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n\tcolor: #fff;\n\ttext-decoration: none;\n}\n\na:visited {\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\na:active {\n    text-decoration: underline;\n}\n\n.sidemenu-container {\n\tbackground-color: #0E1C36;\n\tmin-height: 100%;\n\tpadding-bottom: 20px;\n}\n\n.sidemenu-item {\n\tcolor: #fff;\n\twidth: 180px;\n\ttext-align: center;\n\tpadding: 10px;\n\tfont-size: 16px;\n}\n\n.sidemenu-item img {\n\theight: 80px;\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n}\n\n.sidemenu-item-language {\n\tcolor: #fff;\n\twidth: 180px;\n\ttext-align: center;\n\tpadding: 10px;\n\tfont-size: 16px;\n}\n\n.sidemenu-item-language img {\n\tmargin: 5px;\n}\n\n.sidemenu-separator {\n\tborder-bottom: 1px solid rgba(255,255,255,0.2);\n\tpadding-top: 10px;\n\tmargin-bottom: 10px;\n\twidth: 100%;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.sidemenu-balance-low-warning {\n\tcolor: black;\n\tbackground: yellow;\n\tpadding: 6px;\n\tmargin-bottom: 10px;\n\tborder-radius: 5px;\n\tfont-size: 12px;\n}\n\n.sidemenu-balance-low-warning img {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/sidemenu/sidemenu.component.css
// module id = 545
// module chunks = 1